module.exports = __webpack_public_path__ + "img/swiper_3.5_4_1.40adb039.webp";